import { is } from 'ramda'

export const LOCATION_ACCESS_DECLINED = 'Location Access Declined'

export default function () {
  return this.sendEventWithCallback('location.request', {})
    .then(data => {
      // shortcut
      if (is(Object, data.location)) {
        return data
      }

      return Promise.reject(new Error(
        (data?.location === null)
          ? LOCATION_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
